<template>
  <div class="layout">

    <div class="side">
      <div style="width: 100%;height: 100%">
        <div
          style="width: 100%;height: 10% ;display: flex;justify-content: space-around;align-items: center;border-bottom: 1px solid ;">
          <img src="../assets/apk.png" width="20%" height="40%" style="margin-left: 10px;margin-top: 5px;">
          <div style="color: white;">APK后台管理系统</div>
        </div>
        <div style="width: 100%;height: 90%">
          <sidebar />
        </div>
      </div>

    </div>


    <div class="main">

      <div style="width: 100%;height: 40px;display: flex;justify-content: flex-end;align-items: center;">



        <div style="margin-right: 20px;cursor: pointer ;">

          <el-popconfirm confirm-button-text='好的' @confirm="confirm" cancel-button-text='不用了' icon="el-icon-info"
            icon-color="red" title="修改密码">
            <span class="user_text" slot="reference">欢迎！用户：{{ user }}</span>
          </el-popconfirm>
        </div>

        <div class="exit_" @click="logout"
          style="margin-right: 20px; width: 5%;display: flex;justify-content: center;align-items: center;border: 1px solid gray;border-radius: 10px;cursor: pointer;">
          退出
          <img src="../assets/exit.png" alt="" style="width: 20px;">
        </div>

        <el-dialog custom-class="dialog" title="修改密码" :show-close="showClose" :visible.sync="dialogVisible" width="22%">

          <el-form ref="form" :model="form" label-width="140px">

            <el-form-item label="旧密码">
              <el-input type="password" v-model="form.password1" placeholder="请输入旧密码"></el-input>

            </el-form-item>

            <el-form-item label="新密码">
              <el-input type="password" v-model="form.password" placeholder="请输入新密码"></el-input>

            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="confirmUpdate('form')">确 定</el-button>
          </span>
        </el-dialog>
        
      </div>

      <router-view></router-view>

     

    </div>

    
  

  </div>
</template>

<script>

import sidebar from './sidebar';
import mainn from "./main.vue"
import { removeToken, getUser } from '@/utils/auth';
import { logout, updatePassword } from '@/api/user';


export default {
  name: "home",
  components: { sidebar, mainn },
  data() {

    return {
      user: undefined,
      showClose: true,
      dialogVisible: false,
      form: { password1: '', username: '', password: '' },
    }
  },
  created() {
    this.user = getUser()
  },
  methods: {
    confirm() {
      this.dialogVisible = true
      this.form = {}

    },
    cancel() {
      this.dialogVisible = false

    },
    confirmUpdate() {

      console.log(this.form.password1);
      if (this.form.password1 == '' || this.form.password1 == undefined) {
        this.$message({
          showClose: true,
          message: '旧密码为空',
          type: 'error'
        });
        return
      }

      if (this.form.password == '' || this.form.password == undefined) {
        this.$message({
          showClose: true,
          message: '新密码为空',
          type: 'error'
        });
        return
      }
      this.form.username = this.user
      let data = this.form
      updatePassword(data).then((res) => {
        if (res.data == 1) {
          this.$message({
            showClose: true,
            message: '更新成功',
            type: 'success'
          });
          this.dialogVisible = false
        } else {
          this.$message({
            showClose: true,
            message: '旧密码错误',
            type: 'error'
          });
        }

      }).catch(() => {

      })

    },
    logout() {
      this.$confirm('确定注销并退出系统吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        logout().then(() => {


          this.$router.push('/index/loading2');
          removeToken()
          console.log("logout")
        }).catch((res) => {

        })

      }).catch(() => {

      });


    }

  }
}


</script>

<style>
body {
  margin: auto;
  /* overflow: hidden; */
}

.layout {
  width: 100%;
  height: 100vh;
  display: flex;
  margin: auto;
  overflow: hidden;



}

/* ::-webkit-scrollbar {
  width: 1;
} */

.side {
  width: 12%;
  height: 100%;
  background-color: #545c64;


}

.main {
  width: 88%;
  height: 100%;
  overflow: auto;

}

.user_text:hover {
  color: #409eff;
}

.exit_:hover {
  color: #409eff;

}
</style>